

export function openLink(video) {
  let name = `${video.slug.current}/FILES`;
  let local = window.location.href;
  let url_parts = local.split('/');
  url_parts[url_parts.length - 1] = encodeURI(name);
  return `vectric://open?dir=${url_parts.join('/')}`;
}

/**
 * Returns a link to where the local video would be if it existed
 * It should be at >slug>/<slug>.mp4
 * @param video
 * @returns {string}
 */
export function localVideoLink(video) {
  return `${video.slug.current}/${video.slug.current}.mp4`
}
